export default __webpack_public_path__ + "static/media/chevron-forward-outline.bfe54eaa.svg";